import React, { FC } from "react";

import MaterialList, { ListProps } from "@mui/material/List";

export const List: FC<ListProps> = (props) => (
  <MaterialList {...props}>
    {props.children}
  </MaterialList>
);
